import {Button, Modal} from "react-bootstrap";
import {boldTextStyles, regularTextStyles, subHeadingStyles} from "../Style";

function ContinueOfflinePopupProspectFailed(props) {
    const handleClose = () => {
        props.setParentContinueOfflinePopupShow(false);
    };


    return (
        <>
            <Modal
                show={props.parentContinueOfflinePopupShow}
                onHide={handleClose}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton style={{background: "#E5E7EB"}}>
                    <Modal.Title style={subHeadingStyles}>
                        {" "}
                        Additional Excess
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={regularTextStyles}>
                    <div style={{paddingBottom:"20px"}}>
                        <span style={boldTextStyles}>
                            Age excess
                        </span>
                            <ul style={{ ...regularTextStyles, margin: 0, paddingInlineStart: "1.5rem" }}>
                                <li>$500 - If driver is listed</li>
                                <li>$1,250 - If driver is not listed</li>
                            </ul>
                           <span style={{ ...regularTextStyles, marginTop: "0.25rem" }}> Applies if a driver under 25 years old was driving, using or in charge of your car at the time of the incident.</span>
                    </div>
                    <div style={{paddingBottom:"20px"}}>
                        <span style={boldTextStyles}>
                            Inexperienced driver excess
                        </span>
                        <ul style={{ ...regularTextStyles, margin: 0, paddingInlineStart: "1.5rem" }}>
                            <li>$250 - If driver is listed</li>
                            <li>$700 - If driver is not listed</li>
                        </ul>
                        <span style={{...regularTextStyles, marginTop: "0.25rem"}}>Applies if a driver 25 years old or over, and licensed for the car type for less than 2 years, was driving, using or in charge of your car at the time of an event leading to a claim.</span>
                    </div>
                    <div>
                        <span style={boldTextStyles}>
                            Driver history excess
                        </span>
                        <ul style={{ ...regularTextStyles, margin: 0, paddingInlineStart: "1.5rem" }}>
                            <li>$800</li>
                        </ul>
                        <span style={{ ...regularTextStyles, marginTop: "0.25rem" }}>Applies if a driver who has had their licence cancelled, suspended or disqualified in the last 3 years was driving, using or in charge of your car at the time of the incident.</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ContinueOfflinePopupProspectFailed;